import { type ElementType } from 'react';

import { type QuantitativeSize } from '../../types/sizes';
import { quantitativeSizeToString } from '../../util/sizes';

import { Box, type BoxProps } from './Box';

export type FullyConstrainedSizeProps<E extends ElementType> = {
  readonly height?: QuantitativeSize<'%' | 'px' | 'vh'>;
  readonly width?: QuantitativeSize<'%' | 'px' | 'vw'>;
} & Omit<BoxProps<E>, 'height' | 'width'>;

export const FullyConstrainedSize = <E extends ElementType>(
  props: FullyConstrainedSizeProps<E>,
) => (
  <Box
    {...props}
    height={props.height ? quantitativeSizeToString(props.height, 'px') : undefined}
    maxHeight={
      props.maxHeight ?? (props.height ? quantitativeSizeToString(props.height, 'px') : undefined)
    }
    maxWidth={
      props.maxWidth ?? (props.width ? quantitativeSizeToString(props.width, 'px') : undefined)
    }
    minHeight={
      props.minHeight ?? (props.height ? quantitativeSizeToString(props.height, 'px') : undefined)
    }
    minWidth={
      props.minWidth ?? (props.width ? quantitativeSizeToString(props.width, 'px') : undefined)
    }
    width={props.width ? quantitativeSizeToString(props.width, 'px') : undefined}
  />
);
